(function () {
  'use strict';

  function initialize(){
  if (window.SanoCart && window.SanoCart.initialized) {if(window.SanoCart.root===document.querySelector('[data-sano-cart-drawer]'))return;window.SanoCart.destroy();}
  var disposers=[],disposed=false,savingsFrame=0;
  var temporaryCleanups=new Set(),motionCleanups=new WeakMap();
  function temporary(callback,delay,onCancel){
    var timer=setTimeout(function(){temporaryCleanups.delete(cancel);if(!disposed)callback();},delay);
    function cancel(){clearTimeout(timer);temporaryCleanups.delete(cancel);if(onCancel)onCancel();}
    temporaryCleanups.add(cancel);return cancel;
  }
  disposers.push(function(){Array.from(temporaryCleanups).forEach(function(cancel){cancel();});});
  function listen(target,name,handler,options){target.addEventListener(name,handler,options);disposers.push(function(){target.removeEventListener(name,handler,options);});}

  var root = document.querySelector('[data-sano-cart-drawer]');
  var configNode = document.getElementById('SanoCartConfig');
  if (!root) {
    console.error('[SANO CART] core initialization failed: missing drawer root');
    return;
  }

  var rawConfig = {};
  if (configNode) {
    try {
      rawConfig = JSON.parse(configNode.textContent);
      console.log('[SANO CART] raw config', rawConfig);
    } catch (error) {
      console.error('[SANO CART] config JSON parse failed; optional features disabled', {
        message: error && error.message ? error.message : 'Unknown JSON parse error'
      });
    }
  } else {
    console.warn('[SANO CART] optional config disabled: missing SanoCartConfig element');
  }

  function normalizeConfig(input) {
    var source = input && typeof input === 'object' ? input : {};
    var shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    var normalizedRoot = typeof source.root === 'string' && source.root ? source.root : (shopifyRoot || '/');
    var threshold = Number(source.threshold);
    var productId = source.eligibleProductId == null ? '' : String(source.eligibleProductId);
    var variants = source.eligibleVariants && typeof source.eligibleVariants === 'object' && !Array.isArray(source.eligibleVariants)
      ? source.eligibleVariants : {};

    if (normalizedRoot.slice(-1) !== '/') normalizedRoot += '/';
    if (!Number.isFinite(threshold) || threshold < 2) threshold = 3;

    return {
      cartUrl: typeof source.cartUrl === 'string' && source.cartUrl ? source.cartUrl : normalizedRoot + 'cart',
      continueUrl: typeof source.continueUrl === 'string' && source.continueUrl ? source.continueUrl : normalizedRoot + 'collections/all',
      rewardUrl: typeof source.rewardUrl === 'string' && source.rewardUrl ? source.rewardUrl : '',
      root: normalizedRoot,
      currency: typeof source.currency === 'string' && source.currency ? source.currency : 'EUR',
      locale: typeof source.locale === 'string' && source.locale ? source.locale : 'nl-NL',
      moneyFormat: typeof source.moneyFormat === 'string' ? source.moneyFormat : '',
      eligibleProductId: productId,
      eligibleProductHandle: typeof source.eligibleProductHandle === 'string' ? source.eligibleProductHandle : '',
      eligibleVariants: variants,
      eligibleProductTitle: source.eligibleProductTitle || 'OUTRAGE PRE-WORKOUT',
      previewImage: source.previewImage || '',
      giftAvailable: source.giftAvailable !== false,
      referencePriceVerified: source.referencePriceVerified === true,
      costPriceVerified: source.costPriceVerified === true,
      threshold: threshold,
      copyTwo: typeof source.copyTwo === 'string' && source.copyTwo ? source.copyTwo : 'Nog 2 potten voor je geheime cadeau',
      copyOne: typeof source.copyOne === 'string' && source.copyOne ? source.copyOne : 'Nog 1 pot voor je geheime cadeau',
      copyUnlocked: typeof source.copyUnlocked === 'string' && source.copyUnlocked ? source.copyUnlocked : 'Geheim cadeau ontgrendeld',
      copyUnlockedSubcopy: typeof source.copyUnlockedSubcopy === 'string' ? source.copyUnlockedSubcopy : ''
    };
  }

  var config = normalizeConfig(rawConfig);
  // Owner-declared unavailable; actual physical stock is unchanged.
  var ownerSoldOutVariants={'52393334210897':true};
  // Shopify remains the source of all cart state and payable totals.
  var concept=window.SanoBfConcept;
  var campaignEnabled=Boolean(concept&&concept.enabled&&config.currency==='EUR');
  var previewMode=false;
  var conceptPricing=false; // A real cart always displays Shopify payable amounts, never preview cents.
  var conceptPrices=concept?concept.prices:null;

  function mysterious(title){return /mysteri(?:ous|eus)/i.test(title||'');}
  function mysteryVariant(variant){return Boolean(variant)&&(variant.isMystery===true||mysterious(variant.title));}
  function buildFlavourCards(){
    if(!upsellVariant)return;var holder=root.querySelector('.sano-cart__flavours');if(!holder)return;
    holder.replaceChildren();upsellVariant.replaceChildren();var hasMystery=false;
    Object.keys(config.eligibleVariants).forEach(function(id){var v=config.eligibleVariants[id];if(!v.title)return;var soldOut=v.available!==true||ownerSoldOutVariants[id]===true;var name=mysteryVariant(v)?'Mystery':v.title;hasMystery=hasMystery||mysteryVariant(v);var option=document.createElement('option');option.value=id;option.textContent=name;option.disabled=soldOut;upsellVariant.appendChild(option);
      var button=element('button','sano-cart__flavour');button.type='button';button.dataset.sanoCartFlavour=id;button.dataset.flavourName=name;button.disabled=soldOut;button.hidden=soldOut&&!mysteryVariant(v)&&!/red[ -]?moon|blueberry/i.test(v.title);if(mysteryVariant(v)){button.classList.add('sano-cart__flavour--mystery');}button.setAttribute('aria-label','Voeg 1 '+name+' toe aan je winkelwagen');
      if(v.image||mysteryVariant(v)){var img=document.createElement('img');img.src=v.image||config.previewImage;img.alt='';img.width=48;img.height=48;img.loading='lazy';button.appendChild(img);}
      var copy=element('span','sano-cart__flavour-copy');copy.appendChild(element('strong','',name));copy.appendChild(element('small','',!soldOut?(conceptPricing?formatAccessibleCurrency(conceptPrices.sale):formatAccessibleCurrency(v.price)):'Uitverkocht'));button.appendChild(copy);holder.appendChild(button);
    });
    if(!hasMystery){var button=element('button','sano-cart__flavour sano-cart__flavour--preview');button.type='button';button.disabled=true;button.dataset.sanoCartFlavour='mystery-preview';button.dataset.flavourName='Mystery';button.hidden=false;button.setAttribute('aria-label','Mystery selecteren: preview, nog niet bestelbaar');var img=document.createElement('img');img.src=config.previewImage;img.alt='Mysterious — preview';img.width=48;img.height=48;img.loading='lazy';button.appendChild(img);var copy=element('span','sano-cart__flavour-copy');copy.appendChild(element('strong','','Mystery'));copy.appendChild(element('small','',''));button.appendChild(copy);holder.appendChild(button);}
    Array.from(holder.children).forEach(function(card){
      var cell=element('div','sano-cart__flavour-cell');holder.insertBefore(cell,card);cell.appendChild(card);
      var shortcuts=element('div','sano-cart__bulk-options');shortcuts.setAttribute('role','group');
      var label=card.querySelector('strong').textContent;shortcuts.setAttribute('aria-label','Meer potten '+label+' toevoegen');
      [2,3].forEach(function(amount){var button=element('button','sano-cart__bulk-add');button.type='button';button.dataset.sanoCartFlavour=card.dataset.sanoCartFlavour||'';button.dataset.addQuantity=String(amount);button.disabled=card.disabled;button.setAttribute('aria-label','Voeg '+amount+' potten '+label+' toe');button.appendChild(element('span','','+'+amount));button.appendChild(element('small','visually-hidden',''));shortcuts.appendChild(button);});
      cell.hidden=card.hidden;cell.appendChild(shortcuts);
    });
    holder.style.setProperty('--sano-flavour-count',Math.max(1,Array.from(holder.children).filter(function(cell){return !cell.hidden;}).length));
    var first=Array.prototype.find.call(upsellVariant.options,function(o){return !o.disabled;});if(first)upsellVariant.value=first.value;

  }

  window.SanoThemeConfig = window.SanoThemeConfig || {};
  window.SanoThemeConfig.cart = config;
  console.log('[SANO CART] normalized config', {
    enabled: window.SanoThemeConfig.cartDrawerEnabled === true,
    routesAvailable: Boolean(config.root && config.cartUrl),
    rewardEnabled: Boolean(config.eligibleProductId),
    eligibleProductId: config.eligibleProductId,
    eligibleProductHandle: config.eligibleProductHandle,
    eligibleVariantCount: Object.keys(config.eligibleVariants).length,
    threshold: config.threshold,
    deliveryEnabled: Boolean(root.querySelector('[data-sano-cart-delivery]')),
    savingsEnabled: Object.keys(config.eligibleVariants).length > 0
  });

  // Qikify's app embed is retained for rollback, but must not auto-open in Sano test mode.
  if (window.Qsc2Data && window.Qsc2Data.settings) {
    if (window.Qsc2Data.settings.data) {
      window.Qsc2Data.settings.data.sc_auto_open_drawer = false;
    } else {
      window.Qsc2Data.settings.sc_auto_open_drawer = false;
    }
  }

  var panel = root.querySelector('.sano-cart__panel');
  var itemsNode = root.querySelector('[data-sano-cart-items]');
  var countNode = root.querySelector('[data-sano-cart-count]');
  var totalNode = root.querySelector('[data-sano-cart-total]');
  var discountsNode = root.querySelector('[data-sano-cart-discounts]');
  var savingsNode = root.querySelector('[data-sano-cart-savings]');
  var savingsValue = root.querySelector('[data-sano-cart-savings-value]');
  var reviewsNode = root.querySelector('[data-sano-cart-reviews]');
  var reviewNodes = root.querySelectorAll('[data-sano-cart-reviews]');
  var deliveryNode = root.querySelector('[data-sano-cart-delivery]');
  var rewardNode = root.querySelector('[data-sano-cart-reward]');
  var rewardTitle = root.querySelector('[data-sano-cart-reward-title]');
  var rewardSubcopy = root.querySelector('[data-sano-cart-reward-subcopy]');
  var rewardProgress = root.querySelector('[data-sano-cart-reward-progress]');
  var upsellNode = root.querySelector('[data-sano-cart-upsell]');
  var upsellTitle = root.querySelector('[data-sano-cart-upsell-title]');
  var upsellCopy = root.querySelector('[data-sano-cart-upsell-copy]');
  var upsellVariant = root.querySelector('[data-sano-cart-upsell-variant]');
  var errorNode = root.querySelector('[data-sano-cart-error]');
  var errorText = root.querySelector('[data-sano-cart-error-text]');
  var liveNode = root.querySelector('[data-sano-cart-live]');
  var noteNode = root.querySelector('[data-sano-cart-note]');
  var footerNode = root.querySelector('.sano-cart__footer');
  var missingCore = [];
  if (!panel) missingCore.push('panel');
  if (!itemsNode) missingCore.push('items container');
  if (!countNode) missingCore.push('cart count');
  if (!totalNode) missingCore.push('subtotal');
  if (!footerNode) missingCore.push('footer');
  if (!errorNode || !errorText) missingCore.push('error region');
  if (!liveNode) missingCore.push('live region');
  if (missingCore.length) {
    console.error('[SANO CART] core initialization failed: missing ' + missingCore.join(', '));
    return;
  }
  var lastCart = null;
  var lastEligibleQuantity = null;
  var lastSavingsAmount = null;
  var pendingSavingsIncrease = false;
  var lastTrigger = null;
  var isOpen = false;
  var requestInFlight = false;
  var queuedChanges = Object.create(null);
  var pendingReads = 0;
  var checkoutWaiting = false;
  var checkoutAttempt = 0;
  var savedScroll = null;
  var checkoutNode = root.querySelector(".sano-cart__checkout");
  var checkoutLabel = checkoutNode.textContent;
  var checkoutFeedback=element('p','sano-cart__checkout-feedback');checkoutFeedback.id='SanoCartCheckoutFeedback';checkoutFeedback.setAttribute('role','status');checkoutFeedback.setAttribute('tabindex','-1');checkoutFeedback.hidden=true;checkoutFeedback.textContent='';(root.querySelector('.sano-cart__payments')||checkoutNode).after(checkoutFeedback);disposers.push(function(){checkoutFeedback.remove();});
  if(campaignEnabled){checkoutLabel='VEILIG AFREKENEN';checkoutNode.textContent=checkoutLabel;}
  if(campaignEnabled){checkoutNode.setAttribute('href',config.root+'checkout');checkoutNode.removeAttribute('aria-disabled');checkoutNode.setAttribute('role','button');checkoutNode.setAttribute('tabindex','0');checkoutNode.setAttribute('aria-describedby',checkoutFeedback.id);}
  function blockedCheckout(message){checkoutFeedback.hidden=false;checkoutFeedback.textContent=message||'Je kunt in deze preview nog niet afrekenen.';checkoutFeedback.focus({preventScroll:true});announce(checkoutFeedback.textContent);}
  listen(checkoutNode,'keydown',function(event){if(event.key===' '){event.preventDefault();checkout(event);}});
  function campaignCartMatches(cart){return cart&&cart.currency==='EUR'&&cart.item_count>0&&Number.isFinite(cart.total_price)&&cart.total_price>=0&&cart.items.every(function(item){return !isEligibleItem(item)||Number(item.final_price)===Number(concept.prices.sale)&&Number(item.final_line_price)===Number(concept.prices.sale)*item.quantity;});}

  var intendedQuantities = Object.create(null);
  var noteDirty = false;
  var closeTimer = null;
  var openingPromise = null;
  var retryPromise = null;
  var retryTimer = null;
  var cartFailure = null;
  var lastValidCart = null;
  var readBlockedUntil = 0;
  var giftBlockedUntil = 0;
  try { readBlockedUntil = Number(sessionStorage.getItem('sano-cart-retry-at') || 0); giftBlockedUntil = Number(sessionStorage.getItem('sano-gift-retry-at') || 0); } catch (_) {}
  var retryNode = root.querySelector('[data-sano-cart-retry]');
  if (noteNode) listen(noteNode,'input', function () { noteDirty = true; });
  var focusableSelector = 'summary, a[href], button:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var routeRoot = config.root;

  function endpoint(path) { return routeRoot + path.replace(/^\//, ''); }

  function validCart(cart) {
    return Boolean(cart && Array.isArray(cart.items) && Number.isInteger(cart.item_count) && cart.item_count >= 0
      && Number.isInteger(cart.total_price) && cart.total_price >= 0
      && cart.items.every(function (item) { return item && typeof item.key === 'string' && Number.isInteger(item.quantity)
        && item.quantity > 0 && Number.isInteger(item.final_line_price) && item.final_line_price >= 0; })
      && cart.items.reduce(function (sum, item) { return sum + item.quantity; }, 0) === cart.item_count);
  }
  function cartError(code, status, retryAt) {
    var messages = {
      RATE_LIMITED: 'Shopify verwerkt tijdelijk te veel aanvragen. Wacht even en probeer opnieuw. Je winkelwagen blijft bewaard.',
      UNAVAILABLE: 'Dit aantal of product is momenteel niet beschikbaar. Controleer je winkelwagen en probeer opnieuw.',
      SERVER: 'Shopify is tijdelijk niet bereikbaar. Je winkelwagen blijft bewaard. Probeer opnieuw.',
      INVALID: 'De winkelwagen kon niet veilig worden geladen. Probeer opnieuw.',
      NETWORK: 'De verbinding met Shopify is onderbroken. Controleer je winkelwagen via Opnieuw proberen voordat je verdergaat.',
      TIMEOUT: 'Shopify reageert niet op tijd. Controleer je winkelwagen via Opnieuw proberen voordat je verdergaat.'
    };
    var error = new Error(messages[code] || messages.SERVER);
    error.code = code; error.status = status || 0; error.retryAt = retryAt || 0;
    return error;
  }
  function request(path, options) {
    if (Date.now() < readBlockedUntil) return Promise.reject(cartError('RATE_LIMITED', 429, readBlockedUntil));
    var settings = Object.assign({}, options || {}), controller = new AbortController();
    settings.credentials = 'same-origin'; settings.signal = controller.signal;
    settings.headers = Object.assign({ Accept: 'application/json' }, settings.headers || {});
    var timeout = window.setTimeout(function () { controller.abort(); }, 12000);
    return fetch(endpoint(path), settings).then(function (response) {
      var type = response.headers.get('content-type') || '';
      if (response.status === 429) {
        var retry = response.headers.get('retry-after'), seconds = Number(retry);
        var delay = retry && Number.isFinite(seconds) ? seconds * 1000 : (retry ? Date.parse(retry) - Date.now() : 30000);
        readBlockedUntil = Date.now() + Math.max(1000, Number.isFinite(delay) ? delay : 30000);
        try { sessionStorage.setItem('sano-cart-retry-at', String(readBlockedUntil)); } catch (_) {}
        throw cartError('RATE_LIMITED', 429, readBlockedUntil);
      }
      if (!response.ok) {
        var error=cartError(response.status === 422 || response.status === 404 ? 'UNAVAILABLE' : 'SERVER', response.status);
        // Preserve Shopify's rejection reason, displayed only through textContent.
        if((response.status===422||response.status===404)&&/(json|javascript)/i.test(type)){
          return response.json().catch(function(){return null;}).then(function(payload){
            if(payload&&typeof payload.description==='string'){
              var reason=payload.description;
              if(/sold out|out of stock|uitverkocht|niet op voorraad/i.test(reason))error.message='Shopify geeft deze smaak nog niet vrij voor online bestellingen. Controleer de beschikbare voorraad en de gekoppelde verzendlocatie.';
              else if(/can.t add more|not enough|quantity|quantities|available|aantal|voorraad/i.test(reason))error.message='Het gekozen aantal is momenteel niet beschikbaar. Controleer je winkelwagen en kies minder potten.';
              // Unknown API wording keeps the safe, Dutch fallback; never show raw English.
            }
            throw error;
          });
        }
        throw error;
      }
      if (!/(json|javascript)/i.test(type)) throw cartError('INVALID', response.status);
      return response.json().catch(function () { throw cartError('INVALID', response.status); }).then(function (payload) {
        var isCart = !/cart\/add\.js/.test(path);
        if (isCart ? !validCart(payload) : !(payload && (Array.isArray(payload.items) && payload.items.length || payload.variant_id || payload.id))) throw cartError('INVALID', response.status);
        return payload;
      });
    }).catch(function (error) {
      if (typeof error.code !== 'string') error = cartError(error.name === 'AbortError' ? 'TIMEOUT' : 'NETWORK');
      // Diagnostics deliberately exclude response bodies, cart tokens and cookies.
      console.warn('[SANO CART] request failed', { endpoint: path.split('?')[0], method: settings.method || 'GET', status: error.status, code: error.code });
      throw error;
    }).finally(function () { window.clearTimeout(timeout); });
  }

  // One promotion synchronizer. Shopify alone determines the payable price.
  var giftVariantId = 54664967717201;
  var cartSyncPromise = null;
  var cartReadSequence = 0;
  function readCurrentCart() {
    return request('cart.js?_sano=' + Date.now() + '-' + (++cartReadSequence), { cache: 'no-store' });
  }
  function isAutomaticGift(item) {
    return Number(item.variant_id) === giftVariantId && item.properties
      && item.properties._sano_gift === 'creatine';
  }
  function synchronizeGift(cart) {
    var qualifies = !conceptPricing && cart.items.some(function (item) {
      return item.handle === 'outrage-pre-workout' && item.quantity > 0;
    });
    var gifts = cart.items.filter(isAutomaticGift);
    var normalCreatine = cart.items.some(function (item) {
      return Number(item.variant_id) === giftVariantId && !isAutomaticGift(item);
    });
    var updates = {};
    gifts.forEach(function (item, index) {
      var wanted = qualifies && !normalCreatine && index === 0 && item.final_line_price === 0 ? 1 : 0;
      if (item.quantity !== wanted) updates[item.key] = wanted;
    });
    if (Object.keys(updates).length) {
      return request('cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    }
    // Respect an existing customer-selected pot; never convert or delete it.
    if (!qualifies || normalCreatine || gifts.length || !config.giftAvailable || Date.now() < giftBlockedUntil) return Promise.resolve(cart);
    return request('cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: giftVariantId, quantity: 1, properties: { _sano_gift: 'creatine' } }] })
    }).then(readCurrentCart).then(function (fresh) {
      var gift = fresh.items.find(isAutomaticGift);
      var stillQualifies = fresh.items.some(function (item) { return item.handle === 'outrage-pre-workout' && item.quantity > 0; });
      if (gift && (!stillQualifies || gift.final_line_price !== 0)) {
        // Never leave an unexpectedly paid automatic gift in the cart.
        return request('cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: gift.key, quantity: 0 })
        }).then(function (cleanCart) {
          if (stillQualifies) console.warn('[SANO CART] Gift not free; automatic line removed.');
          return cleanCart;
        });
      }
      return fresh;
    });
  }
  function reconcileGift(cart) {
    return synchronizeGift(cart).catch(function (error) {
      giftBlockedUntil = Date.now() + 300000;
      try { sessionStorage.setItem('sano-gift-retry-at', String(giftBlockedUntil)); } catch (_) {}
      // Definitive rejection cannot have added the gift. Keep the valid cart.
      if (!cart.items.some(isAutomaticGift) && (error.status === 422 || error.status === 404)) return cart;
      // Ambiguous writes are never replayed. Manual retry reads actual Shopify state.
      throw error;
    });
  }
  function getCart() {
    if (cartSyncPromise) return cartSyncPromise;
    pendingReads++;
    cartSyncPromise = readCurrentCart().then(function (cart) {
      lastValidCart = cart;
      return reconcileGift(cart);
    }).then(function (cart) { lastValidCart = cart; return cart; }).finally(function () {
      pendingReads--; cartSyncPromise = null;
    });
    return cartSyncPromise;
  }
  function acceptMutationCart(cart) {
    if (!validCart(cart)) throw cartError('INVALID');
    lastValidCart = cart;
    return reconcileGift(cart);
  }

  function readAfterConfirmedAdd(){
    // A fresh read after the write must not reuse an older in-flight cart snapshot.
    return readCurrentCart().then(function(cart){lastValidCart=cart;return reconcileGift(cart);}).catch(function(error){
      if(error.status===429)throw error;
      // Retry only a read; never replay the accepted add or an ambiguous gift write.
      return readCurrentCart().then(function(cart){
        if(cart.items.some(function(item){return isAutomaticGift(item)&&item.final_line_price!==0;}))throw error;
        lastValidCart=cart;return cart;
      });
    });
  }
  var blockedAddRecovery=false;
  function normalizedCents(cents) {
    var amount = Math.round(Number(cents));
    return Number.isFinite(amount) ? amount : 0;
  }

  function formatCartPriceNoCurrency(cents) {
    var amount = normalizedCents(cents);
    var absoluteAmount = Math.abs(amount);
    var hasWholeEuros = absoluteAmount % 100 === 0;
    var value = absoluteAmount / 100;
    var options = hasWholeEuros
      ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    var formatted;

    try {
      formatted = new Intl.NumberFormat('nl-NL', options).format(value);
    } catch (error) {
      formatted = hasWholeEuros ? String(value) : value.toFixed(2).replace('.', ',');
    }

    return (amount < 0 ? '\u2212' : '') + formatted + (hasWholeEuros ? ',-' : '');
  }

  function formatSavingsWithCurrency(cents) {
    var amount = Math.abs(normalizedCents(cents));
    var formatted;

    try {
      formatted = new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount / 100);
    } catch (error) {
      formatted = (amount / 100).toFixed(2).replace('.', ',');
    }

    return '\u20AC' + formatted;
  }

  function formatAccessibleCurrency(cents) {
    var amount = normalizedCents(cents);
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: config.currency || 'EUR' }).format(amount / 100);
    } catch (error) {
      return formatCartPriceNoCurrency(amount) + ' euro';
    }
  }

  function formatMoney(cents) {
    return formatCartPriceNoCurrency(cents);
  }

  function announce(message) {
    liveNode.textContent = '';
    window.setTimeout(function () { liveNode.textContent = message; }, 20);
  }

  function showError(error) {
    cartFailure = error instanceof Error ? error : new Error(error || 'Er ging iets mis. Probeer het opnieuw.');
    errorText.textContent = cartFailure.message;
    errorNode.hidden = false;
    window.clearTimeout(retryTimer);
    function updateRetry() {
      var seconds = Math.max(0, Math.ceil(((cartFailure && cartFailure.retryAt) || 0) - Date.now()) / 1000);
      seconds = Math.ceil(seconds);
      retryNode.disabled = seconds > 0 || Boolean(retryPromise);
      retryNode.textContent = seconds > 0 ? 'Opnieuw proberen (' + seconds + ' s)' : 'Opnieuw proberen';
      if (seconds > 0) retryTimer = window.setTimeout(updateRetry, 1000);
    }
    updateRetry();
  }
  function clearError() {
    cartFailure = null; errorNode.hidden = true;
    window.clearTimeout(retryTimer);
    retryNode.disabled = false; retryNode.textContent = 'Opnieuw proberen';
  }
  function retryCart() {
    if (retryPromise || requestInFlight || Date.now() < readBlockedUntil) return;
    retryNode.disabled = true;
    retryPromise = getCart().then(function (cart) { render(cart); clearError(); }).catch(showError).finally(function () {
      retryPromise = null;
      if (cartFailure) showError(cartFailure); else retryNode.disabled = false;
    });
  }

  function retrigger(node, className) {
    if (!node || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var motions=motionCleanups.get(node);if(!motions){motions=new Map();motionCleanups.set(node,motions);}
    if(motions.has(className))motions.get(className)();
    node.classList.remove(className);void node.offsetWidth;node.classList.add(className);
    var cancel=temporary(cleanup,1600,detach);
    function detach(){node.removeEventListener('animationend',ended);motions.delete(className);}
    function cleanup(){cancel();node.classList.remove(className);}
    function ended(event){if(event.target===node)cleanup();}
    motions.set(className,cleanup);node.addEventListener('animationend',ended);
  }

  function eligibleQuantity(cart) {
    var productId = Number(config.eligibleProductId || 0);
    if (!productId) return 0;
    return cart.items.reduce(function (sum, item) {
      return sum + (isEligibleItem(item) ? Number(item.quantity) : 0);
    }, 0);
  }

  function isEligibleItem(item) {
    return Boolean(item) && (Number(item.product_id) === Number(config.eligibleProductId || 0) || Object.keys(config.eligibleVariants).some(function(id){var v=config.eligibleVariants[id];return mysteryVariant(v)&&Number(v.productId)===Number(item.product_id);}));
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text !== 'undefined') node.textContent = text;
    return node;
  }

  function renderProperties(item, parent) {
    if (!item.properties) return;
    Object.keys(item.properties).forEach(function (name) {
      var value = item.properties[name];
      if (!value || name.charAt(0) === '_') return;
      parent.appendChild(element('div', 'sano-cart__property', name + ': ' + value));
    });
  }

  function quantityButton(label, symbol, key, quantity) {
    var button = element('button', '');
    button.type = 'button';
    button.setAttribute('aria-label', label);
    button.dataset.sanoCartChange = key;
    button.dataset.quantity = quantity;
    button.dataset.quantityDelta = symbol === '+' ? '1' : '-1';
    button.innerHTML = symbol === '+'
      ? '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4v12M4 10h12"/></svg>'
      : '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h12"/></svg>';
    return button;
  }

  function animateCartAmount(node, from, to, format) {
    if(from===to||!Number.isFinite(from)||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var start=null,version=Number(node.dataset.sanoAmountVersion||0)+1;
    node.dataset.sanoAmountVersion=String(version);
    node.classList.add('is-amount-rolling');
    function tick(now){
      if(disposed||!node.isConnected||Number(node.dataset.sanoAmountVersion)!==version)return;
      if(start===null)start=now;
      var t=Math.min(1,(now-start)/520),ease=1-Math.pow(1-t,3);
      node.textContent=format(Math.round(from+(to-from)*ease));
      if(t<1)window.requestAnimationFrame(tick);
      else{node.textContent=format(to);node.classList.remove('is-amount-rolling');}
    }
    window.requestAnimationFrame(tick);
  }

  function renderItem(item, previousItem) {
    var article = element('article', 'sano-cart__item');
    if (!previousItem) article.classList.add('is-entering');
    else if (previousItem.quantity !== item.quantity || previousItem.final_line_price !== item.final_line_price) article.classList.add('is-updated');
    article.dataset.lineKey = item.key;

    var imageWrap = element('div', 'sano-cart__item-image');
    var catalogVariant=config.eligibleVariants[String(item.variant_id)];
    var imageSource=catalogVariant&&mysteryVariant(catalogVariant)?catalogVariant.image:(catalogVariant&&catalogVariant.image)||item.image;
    if (imageSource) {
      var image = document.createElement('img');
      image.src = imageSource;
      image.alt = (item.product_title || item.title || '') + (item.variant_title && item.variant_title !== 'Default Title' ? ' - ' + item.variant_title : '');
      image.width = 88;
      image.height = 88;
      image.loading = 'lazy';
      imageWrap.appendChild(image);
    }

    var info = element('div', 'sano-cart__item-info');
    // Keep the canonical product name local to this cart line only. Never scan or
    // rewrite the surrounding storefront DOM.
    var isCanonicalOutrage = String(item.handle || '').toLowerCase() === 'outrage-pre-workout'
      || String(item.url || '').indexOf('/products/outrage-pre-workout') !== -1;
    var hasNamedFlavour = isCanonicalOutrage && item.variant_title && item.variant_title !== 'Default Title';
    var displayTitle = hasNamedFlavour ? (mysterious(item.variant_title) ? 'Mystery' : item.variant_title) : (isCanonicalOutrage ? 'OUTRAGE PRE-WORKOUT' : (item.product_title || item.title));
    var title = element('a', 'sano-cart__item-title' + (isCanonicalOutrage ? ' sano-cart__item-title--outrage notranslate' : ''), displayTitle);
    title.href = catalogVariant && mysteryVariant(catalogVariant) ? (config.root || '/') + 'products/outrage-pre-workout' : item.url;
    if (isCanonicalOutrage) {
      title.setAttribute('translate', 'no');
      title.setAttribute('data-sano-canonical-product-title', displayTitle);
      title.setAttribute('aria-label', 'OUTRAGE PRE-WORKOUT - ' + displayTitle);
    }
    if(isCanonicalOutrage){title.textContent='OUTRAGE PRE-WORKOUT';title.setAttribute('data-sano-canonical-product-title','OUTRAGE PRE-WORKOUT');}
    info.appendChild(title);

    if (item.variant_title && item.variant_title !== 'Default Title') info.appendChild(element('div', 'sano-cart__variant' + (isCanonicalOutrage && mysterious(item.variant_title) ? ' sano-cart__variant--mysterious' : ''), (mysterious(item.variant_title)?'Mysterious':item.variant_title)));
    renderProperties(item, info);
    // Presentation only: use the existing discount allocation and actual cart price.
    var creatineAllocation = (item.line_level_discount_allocations || []).some(function (allocation) {
      return String(allocation.discount_application && allocation.discount_application.title || '').trim().toLowerCase() === 'gratis creatine';
    });
    var isFreeCreatine = isAutomaticGift(item) && creatineAllocation
      && typeof item.final_line_price === 'number' && item.final_line_price === 0;
    if (isCanonicalOutrage && creatineAllocation) {
      var giftNote = element('div', 'sano-cart__creatine-gift');
      giftNote.appendChild(element('strong', '', 'GRATIS CREATINE'));
      giftNote.appendChild(element('span', '', 't.w.v. €20,00'));
      info.appendChild(giftNote);
    } else if (isFreeCreatine) {
      article.classList.add('sano-cart__item--creatine-gift');
      if (isAutomaticGift(item)) article.classList.add('sano-cart__item--automatic-gift');
      if (!previousItem || previousItem.final_line_price !== 0) article.classList.add('is-gift-revealing');
      info.insertBefore(element('span', 'sano-cart__creatine-badge', '+ CADEAU BIJ OUTRAGE'), title);
      article.appendChild(element('div', 'sano-cart__gift-celebration', 'Ter celebratie van ons nieuwe product'));
    }
    (item.line_level_discount_allocations || []).forEach(function (allocation) {
      var title = allocation.discount_application && allocation.discount_application.title;
      if ((isCanonicalOutrage || isFreeCreatine) && String(title || '').trim().toLowerCase() === 'gratis creatine') return;
      if (title) info.appendChild(element('div', 'sano-cart__property', title + ': −' + formatMoney(allocation.amount)));
    });

    var quantity = element('div', 'sano-cart__quantity');
    quantity.appendChild(quantityButton('Eén minder van ' + item.product_title, '−', item.key, Math.max(0, item.quantity - 1)));
    var output = element('output', '', String(item.quantity));
    output.setAttribute('aria-label', 'Aantal ' + item.product_title);
    quantity.appendChild(output);
    var increaseButton=quantityButton('Eén meer van ' + item.product_title, '+', item.key, item.quantity + 1);
    increaseButton.disabled=Boolean(ownerSoldOutVariants[String(item.variant_id)]);
    quantity.appendChild(increaseButton);
    if (isCanonicalOutrage) info.appendChild(quantity);
    var price = element('div', 'sano-cart__item-price');
    var originalDisplayPrice = referenceLinePrice(item);
    var payable = paidLinePrice(item);
    if (originalDisplayPrice > payable) {
      var comparePrice = element('s', '', formatCartPriceNoCurrency(originalDisplayPrice));
      comparePrice.setAttribute('aria-label', formatAccessibleCurrency(originalDisplayPrice));
      price.appendChild(comparePrice);
    }
    var currentPrice = element('span', '', formatCartPriceNoCurrency(payable));
    currentPrice.setAttribute('aria-label', formatAccessibleCurrency(payable));
    price.appendChild(currentPrice);
    currentPrice.dataset.sanoPayableAmount=String(payable);
    if(isCanonicalOutrage&&previousItem&&!conceptPricing&&previousItem.final_line_price!==payable){
      animateCartAmount(currentPrice,previousItem.final_line_price,payable,formatCartPriceNoCurrency);
    }
    var bfPricing=nativeSalePricing(item);
    if(isCanonicalOutrage&&(conceptPricing||bfPricing)){
      price.classList.add('sano-cart__bf-price');
      if (bfPricing) {
        // Restore the existing premium layout hooks without substituting cart prices.
        price.classList.add('sano-deal', 'sano-concept-cart-price', 'is-concept-complete');
        currentPrice.setAttribute('data-concept-counter', '');
        if (comparePrice) comparePrice.classList.add('sano-deal-reference');
      }
      if(previousItem)price.classList.add(previousItem.quantity!==item.quantity?'is-cart-price-update':'is-cart-price-stable');
      currentPrice.textContent=formatCartPriceNoCurrency(payable);
      if(comparePrice)comparePrice.textContent=conceptPricing?concept.money(originalDisplayPrice):formatSavingsWithCurrency(originalDisplayPrice);
      var badges=element('div','sano-cart__price-badges');
      badges.appendChild(element('span','sano-bf-discount',Math.floor((originalDisplayPrice-payable)/originalDisplayPrice*100)+'% KORTING'));
      if(conceptPricing||bfPricing)badges.appendChild(element('span','sano-bf-cost','INKOOPPRIJS!'));
      price.appendChild(badges);
      if(conceptPricing){currentPrice.setAttribute('data-concept-counter','');price.classList.add('sano-concept-cart-price');requestAnimationFrame(function(){if(price.isConnected)concept.reveal(price,payable,originalDisplayPrice,'cart:'+item.key);});}
    }
    if (isFreeCreatine) {
      // Promotional value is not a Shopify price calculation. The payable value
      // continues to come directly from final_line_price; totals stay untouched.
      price.replaceChildren();
      var giftValue = element('s', '', '€20,00');
      giftValue.setAttribute('aria-label', 'Cadeauwaarde per pot: 20 euro');
      price.appendChild(giftValue);
      currentPrice.textContent = 'GRATIS';
      price.appendChild(currentPrice);
    }
    var remove = element('button', 'sano-cart__remove');
    remove.type = 'button';
    remove.dataset.sanoCartChange = item.key;
    remove.dataset.quantity = '0';
    remove.setAttribute('aria-label', item.product_title + ' verwijderen');
    remove.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5"/></svg>';
    var actions = element('div', 'sano-cart__item-actions');
    if (!isAutomaticGift(item) && !isCanonicalOutrage) actions.appendChild(quantity);
    actions.appendChild(price);
    info.appendChild(actions);

    article.appendChild(imageWrap);
    article.appendChild(info);
    if (!isAutomaticGift(item)) article.appendChild(remove);
    return article;
  }

  function renderReward(cart) {
    var eligible = eligibleQuantity(cart);
    var threshold = Math.max(2, Number(config.threshold || 3));
    if (!config.eligibleProductId || eligible === 0) {
      rewardNode.hidden = true;
      upsellNode.hidden = true;
      lastEligibleQuantity = eligible;
      return;
    }
    rewardNode.hidden = false;
    rewardNode.dataset.rewardState = String(Math.min(threshold, eligible));
    var rewardState = Math.min(threshold, eligible);
    var progress = threshold > 1 ? ((rewardState - 1) / (threshold - 1)) * 100 : 100;
    rewardProgress.style.setProperty('--sano-reward-progress', Math.max(0, Math.min(100, progress)) / 100);
    root.querySelectorAll('[data-reward-step]').forEach(function (step) {
      step.classList.toggle('is-complete', Number(step.dataset.rewardStep) <= rewardState);
      var savingLabel = step.querySelector('.sano-cart__step-saving');
      if (!savingLabel) { savingLabel = element('span', 'sano-cart__step-saving'); step.appendChild(savingLabel); }
      var totalSaving = compareAtSavings(cart);
      var stepQuantity = Number(step.dataset.rewardStep) === threshold ? Math.max(threshold, eligible) : Number(step.dataset.rewardStep);
      savingLabel.hidden=!(totalSaving>0);
      rewardNode.dataset.hasSavings=totalSaving>0?'true':'false';
      savingLabel.textContent = formatSavingsWithCurrency(Math.round(totalSaving / eligible * stepQuantity)) + ' voordeel';
    });
    rewardNode.classList.remove('is-reward-unlocked');
    if (lastEligibleQuantity !== null && eligible !== lastEligibleQuantity) {
      if (eligible > lastEligibleQuantity) {
        retrigger(rewardNode, 'is-add-shining');
        retrigger(rewardNode, eligible >= threshold ? 'is-reward-unlocked' : 'is-reward-advanced');
      } else {
        retrigger(rewardNode, 'is-reward-reversed');
      }
    }
    rewardSubcopy.hidden = true;
    if (eligible >= threshold) {
      rewardTitle.textContent = config.copyUnlocked;
      rewardSubcopy.textContent = config.copyUnlockedSubcopy;
      rewardSubcopy.hidden = false;
      upsellNode.hidden = !upsellVariant || !Array.prototype.some.call(upsellVariant.options,function(option){return !option.disabled;});
    } else {
      rewardTitle.textContent = threshold - eligible === 1 ? config.copyOne : config.copyTwo;
      upsellNode.hidden = !upsellVariant || !Array.prototype.some.call(upsellVariant.options,function(option){return !option.disabled;});
    }
    lastEligibleQuantity = eligible;
  }

  function renderDiscounts(cart) {
    discountsNode.replaceChildren();
    var discounts = cart.cart_level_discount_applications || [];
    if (!discounts.length) { discountsNode.hidden = true; return; }
    discountsNode.hidden = false;
    discounts.forEach(function (discount) {
      discountsNode.appendChild(element('div', '', discount.title + ': −' + formatMoney(discount.total_allocated_amount)));
    });
    Array.prototype.slice.call(discountsNode.children).forEach(function (node, index) {
      var discount = discounts[index] || {};
      var amount = Number(discount.total_allocated_amount || 0);
      if (!(amount > 0)) node.remove();
      else node.textContent = (discount.title || 'Korting') + ': −' + formatMoney(amount);
    });
    if (!discountsNode.children.length) discountsNode.hidden = true;
  }

  function paidLinePrice(item) {
    if(conceptPricing&&isEligibleItem(item))return conceptPrices.sale*item.quantity;
    return Number.isInteger(item.final_line_price) ? item.final_line_price : item.line_price;
  }
  function nativeSalePricing(item) {
    var pricing = config.eligibleVariants[String(item.variant_id)];
    return config.currency === 'EUR' && isEligibleItem(item) && pricing
      && Number.isInteger(pricing.price) && pricing.price >= 0
      && Number.isInteger(pricing.compareAtPrice) && pricing.compareAtPrice > pricing.price
      && Number.isInteger(item.quantity) && item.quantity > 0
      && Number(item.original_line_price) === pricing.price * item.quantity ? pricing : null;
  }
  function referenceLinePrice(item) {
    if(conceptPricing&&isEligibleItem(item))return Number(item.original_price||item.price)*item.quantity;
    var original = Number(item.original_line_price || 0);
    // Reject stale variant data; compare-at changes display savings, never payable totals.
    var pricing = nativeSalePricing(item);
    if (pricing) {
      return Math.max(original, pricing.compareAtPrice * item.quantity);
    }
    return original;
  }
  function compareAtSavings(cart) {
    // Paid line totals already contain allocated discounts; never add total_discount.
    return cart.items.reduce(function (sum, item) {
      if (!isEligibleItem(item) || (item.properties && item.properties._sano_gift)) return sum;
      var paid = paidLinePrice(item), reference = referenceLinePrice(item);
      if (!Number.isInteger(paid) || paid < 0 || !Number.isInteger(reference)) return sum;
      return sum + Math.max(0, reference - paid);
    }, 0);
  }

  function savingsDigits(cents){return new Intl.NumberFormat('nl-NL',{minimumFractionDigits:2,maximumFractionDigits:2}).format(cents/100); }
  function renderSavings(cart) {
    var amount = compareAtSavings(cart);
    if(previewMode)savingsNode.style.setProperty('--concept-glow',String(Math.min(.5,.16+eligibleQuantity(cart)*.045))); 
    savingsNode.hidden = amount <= 0;
    if (amount > 0) {
      window.cancelAnimationFrame(savingsFrame);
      var formattedAmount = savingsDigits(amount);
      var currencySymbol = new Intl.NumberFormat(config.locale,{style:'currency',currency:config.currency}).formatToParts(amount/100).find(function(part){return part.type==='currency';}).value;
      var savingsAmount = element('span', 'sano-cart__savings-amount');
      var savingsNumber = element('span', 'sano-cart__savings-number', formattedAmount);
      savingsNumber.setAttribute('aria-hidden','true');
      var savingsMinus=element('span','sano-cart__savings-minus','-');
      var savingsCurrency=element('span','sano-cart__savings-currency',currencySymbol);
      savingsAmount.setAttribute('aria-hidden','true');
      savingsAmount.appendChild(savingsMinus);savingsAmount.appendChild(savingsCurrency);savingsAmount.appendChild(savingsNumber);
      savingsValue.replaceChildren(savingsAmount);
      savingsValue.setAttribute('aria-label', 'Besparing ' + formatAccessibleCurrency(amount));
      if(lastSavingsAmount!==null&&lastSavingsAmount!==amount&&!matchMedia('(prefers-reduced-motion:reduce)').matches){
        var from=lastSavingsAmount,start=performance.now();
        function tick(now){var t=Math.min(1,(now-start)/480);savingsNumber.textContent=savingsDigits(Math.round(from+(amount-from)*(1-Math.pow(1-t,3))));if(t<1&&!disposed)savingsFrame=requestAnimationFrame(tick);}
        savingsFrame=requestAnimationFrame(tick);
      }
      var savingsIncreased = lastSavingsAmount !== null && amount > lastSavingsAmount;
      savingsNode.classList.remove('is-savings-increased');
      if (savingsIncreased) {
        retrigger(savingsNode, 'is-savings-increased');
        if(previewMode)retrigger(savingsValue,'is-concept-rolling');
      } else if (lastSavingsAmount !== null && lastSavingsAmount !== amount) {
        retrigger(savingsValue, 'is-updated');
      }
    }
    lastSavingsAmount = amount;
    pendingSavingsIncrease = false;
  }

  function renderReviews(cart) {
    // The owner-confirmed cart copy lives only in sano-cart-drawer.liquid.
    // Provider widgets and old fallbacks must not overwrite this component.
    reviewNodes.forEach(function (node) { node.hidden = !cart.item_count; });
  }

  function startDelivery(cart) {
    deliveryNode.dataset.sanoDeliveryEligible = cart.item_count > 0 ? 'true' : 'false';
    if (window.SanoDeliveryClock) window.SanoDeliveryClock.refresh();
    else deliveryNode.hidden = true;
  }

  function syncViewport() {
    if (!isOpen) return;
    var view = window.visualViewport;
    root.style.setProperty('--sano-cart-viewport-height', (view ? view.height : window.innerHeight) + 'px');
    root.style.setProperty('--sano-cart-viewport-top', (view ? view.offsetTop : 0) + 'px');
  }
  function lockPage() {
    if (savedScroll) return;
    savedScroll = { x: window.scrollX, y: window.scrollY, style: document.body.getAttribute('style') };
    Object.assign(document.body.style, { position: 'fixed', top: -savedScroll.y + 'px', left: '0', right: '0', width: '100%' });
  }
  function unlockPage() {
    if (!savedScroll) return;
    var saved = savedScroll; savedScroll = null;
    if (saved.style === null) document.body.removeAttribute('style');
    else document.body.setAttribute('style', saved.style);
    window.scrollTo({ left: saved.x, top: saved.y, behavior: 'instant' });
  }
  function resetCheckout() {
    checkoutWaiting = false;
    checkoutNode.removeAttribute('aria-busy');
    checkoutNode.textContent = checkoutLabel;
  }
  function passwordGateActive(){
    return fetch(endpoint('cart.js'),{credentials:'omit',cache:'no-store',redirect:'manual',headers:{Accept:'application/json'}}).then(function(response){return response.status===401;}).catch(function(){return false;});
  }
  var passwordCheckPending=false;
  function checkout(event,privateAccess) {
    if(window.SanoPrelaunch&&window.SanoPrelaunch.enabled&&!privateAccess){
      event.preventDefault();if(passwordCheckPending)return;passwordCheckPending=true;
      passwordGateActive().then(function(active){if(active)checkout(event,true);else blockedCheckout(window.SanoPrelaunch.checkoutMessage());}).finally(function(){passwordCheckPending=false;});return;
    }
    // The ordinary idle path remains a native Shopify anchor navigation.
    if (!campaignEnabled && !privateAccess && !checkoutWaiting && !requestInFlight && !pendingReads && !Object.keys(queuedChanges).length && !noteDirty && errorNode.hidden) return;
    event.preventDefault();
    if (checkoutWaiting) return;
    if (!errorNode.hidden) { errorNode.scrollIntoView({ block: 'nearest' }); return; }
    checkoutFeedback.hidden=true;checkoutFeedback.replaceChildren();
    checkoutWaiting = true;
    var attempt = ++checkoutAttempt, deadline = Date.now() + 20000;
    checkoutNode.setAttribute('aria-busy', 'true');
    checkoutNode.textContent = 'Winkelwagen bijwerken…';
    function settle() {
      if (attempt !== checkoutAttempt || !isOpen) { resetCheckout(); return; }
      if (!errorNode.hidden || Date.now() > deadline) {
        resetCheckout();
        if (errorNode.hidden) showError('De update duurt te lang. Controleer je winkelwagen en probeer opnieuw.');
        errorNode.scrollIntoView({ block: 'nearest' });
        return;
      }
      if (requestInFlight || pendingReads || Object.keys(queuedChanges).length) { window.setTimeout(settle, 80); return; }
      if (noteDirty) { saveNote(); window.setTimeout(settle, 80); return; }
      resetCheckout();
      if(campaignEnabled||privateAccess){
        checkoutWaiting=true;checkoutNode.setAttribute('aria-busy','true');
        request('cart.js').then(function(cart){
          if(attempt!==checkoutAttempt||!isOpen){resetCheckout();return;}
          var previousTotal=lastCart&&lastCart.total_price;
          render(cart);resetCheckout();
          if(!validCart(cart)||!cart.item_count){blockedCheckout('Je winkelwagen is leeg. Voeg eerst een product toe.');return;}
          if(!privateAccess&&!campaignCartMatches(cart)){blockedCheckout('Afrekenen geblokkeerd: de werkelijke actieprijs klopt nog niet.');return;}
          if(previousTotal!==cart.total_price){blockedCheckout('Je winkelwagen is bijgewerkt. Controleer het bedrag en klik opnieuw op Veilig afrekenen.');return;}
          window.location.assign(config.root+'checkout');
        }).catch(function(){resetCheckout();blockedCheckout('Prijscontrole niet gelukt. Probeer opnieuw.');});return;
      }
      if (lastCart && lastCart.item_count) window.location.assign(checkoutNode.href);
    }
    settle();
  }
  listen(window,'resize', syncViewport);
  if (window.visualViewport) {
    listen(window.visualViewport,'resize', syncViewport);
    listen(window.visualViewport,'scroll', syncViewport);
  }
  listen(window,'pageshow', function () { resetCheckout(); syncViewport(); });

  function renderEnhancementsSafely(cart) {
    [
      ['reward', function () { renderReward(cart); }, rewardNode],
      ['discounts', function () { renderDiscounts(cart); }, discountsNode],
      ['savings', function () { renderSavings(cart); }, savingsNode],
      ['reviews', function () { renderReviews(cart); }, reviewsNode],
      ['delivery', function () { startDelivery(cart); }, deliveryNode]
    ].forEach(function (enhancement) {
      try {
        enhancement[1]();
      } catch (error) {
        if (enhancement[2]) enhancement[2].hidden = true;
        console.error('[SANO CART] optional ' + enhancement[0] + ' render failed', error);
      }
    });
  }

  function render(cart, coreOnly) {
    if (!validCart(cart)) throw cartError('INVALID');
    console.info('[SANO CART] render started');
    var previousItems = Object.create(null);
    if (lastCart && lastCart.items) lastCart.items.forEach(function (item) { previousItems[item.key] = item; });
    var focused = document.activeElement;
    var restoreLineFocus = focused && itemsNode.contains(focused);
    var focusedLabel = restoreLineFocus ? focused.getAttribute('aria-label') : null;
    var focusedLine = restoreLineFocus && focused.closest('[data-line-key]');
    var focusedKey = focusedLine && focusedLine.dataset.lineKey;
    var previousCount = lastCart ? lastCart.item_count : null;
    var previousTotal = lastCart ? lastCart.total_price : null;
    lastCart = cart;
    // Preserve unchanged lines and their decoded images; fresh Shopify data still wins.
    var existingLines = Object.create(null), orderedNodes = [];
    Array.prototype.forEach.call(itemsNode.children, function (node) { if (node.dataset.lineKey) existingLines[node.dataset.lineKey] = node; });
    function appendLine(item) {
      var previous = previousItems[item.key], existing = existingLines[item.key];
      var unchanged = existing && previous && JSON.stringify(previous) === JSON.stringify(item);
      orderedNodes.push(unchanged ? existing : renderItem(item, previous));
    }
    countNode.textContent = cart.item_count;
    var displayTotal=conceptPricing?cart.items.reduce(function(total,item){return total+(isEligibleItem(item)?paidLinePrice(item)-item.final_line_price:0);},cart.total_price):cart.total_price;
    totalNode.textContent = formatCartPriceNoCurrency(displayTotal);
    totalNode.setAttribute('aria-label', formatAccessibleCurrency(displayTotal));
    if(previousTotal!==null&&previousTotal!==displayTotal)animateCartAmount(totalNode,previousTotal,displayTotal,formatCartPriceNoCurrency);
    if (previousCount !== null && previousCount !== cart.item_count) retrigger(countNode, 'is-updated');
    if (previousTotal !== null && previousTotal !== cart.total_price) retrigger(totalNode, 'is-updated');
    footerNode.hidden = cart.item_count === 0;
    if(!previewMode)document.querySelectorAll('[data-cart-count]').forEach(function (node) { node.textContent = cart.item_count; });

    if (!cart.items.length) {
      var empty = itemsNode.querySelector('.sano-cart__empty');
      if (!empty) {
      empty = element('div', 'sano-cart__empty');
      empty.appendChild(element('p', '', 'Je winkelwagen is leeg.'));
      var continueLink = element('a', '', 'Bekijk OUTRAGE');
      continueLink.href = config.rewardUrl || config.continueUrl;
      empty.appendChild(continueLink);
      }
      orderedNodes.push(empty);
    } else {
      var giftLines = cart.items.filter(isAutomaticGift);
      var giftPlaced = false;
      cart.items.filter(function (item) { return !isAutomaticGift(item); }).forEach(function (item) {
        appendLine(item);
        if (!giftPlaced && item.handle === 'outrage-pre-workout') {
          giftLines.forEach(function (gift) { appendLine(gift); });
          giftPlaced = true;
        }
      });
      if (!giftPlaced) giftLines.forEach(function (gift) { appendLine(gift); });
    }
    var cursor = itemsNode.firstChild;
    orderedNodes.forEach(function (node) {
      if (node === cursor) cursor = cursor.nextSibling;
      else itemsNode.insertBefore(node, cursor);
    });
    while (cursor) { var next = cursor.nextSibling; cursor.remove(); cursor = next; }
    if (noteNode && !noteDirty) noteNode.value = cart.note || '';
    if (restoreLineFocus && isOpen) {
      var line = Array.prototype.find.call(itemsNode.querySelectorAll('[data-line-key]'), function (node) { return node.dataset.lineKey === focusedKey; });
      var nextFocus = line && Array.prototype.find.call(line.querySelectorAll('[aria-label]'), function (node) { return node.getAttribute('aria-label') === focusedLabel; });
      (nextFocus || itemsNode.querySelector('button') || panel.querySelector('[data-sano-cart-close]')).focus({ preventScroll: true });
    }
    console.info('[SANO CART] cart count updated', cart.item_count);
    console.info('[SANO CART] render complete');
    if (!coreOnly) renderEnhancementsSafely(cart);
  }

  function focusables() { return Array.prototype.slice.call(panel.querySelectorAll(focusableSelector)).filter(function (node) { return !node.hidden && node.offsetParent !== null; }); }

  function open(cart, trigger) {
    if(previewMode)cart=null;
    if (isOpen) return openingPromise || Promise.resolve(lastCart);
    window.clearTimeout(closeTimer);
    lastTrigger = trigger || document.activeElement;
    root.querySelectorAll('details').forEach(function (details) { details.open = false; });
    lockPage();
    document.documentElement.classList.add('sano-cart-open');
    document.body.classList.add('sano-cart-open');
    root.hidden = false; root.setAttribute('aria-hidden', 'false');
    isOpen = true; syncViewport();
    if (lastCart || lastValidCart) render(lastCart || lastValidCart);
    else { itemsNode.textContent = 'Winkelwagen laden…'; footerNode.hidden = true; }
    window.requestAnimationFrame(function () { if (isOpen) { root.classList.add('is-open'); panel.focus({ preventScroll: true }); } });
    // Reopening during a read must restore the shell immediately, sharing that read.
    if (openingPromise) return openingPromise;
    // A current full Cart API response supplied by the product form needs no second GET.
    openingPromise = (validCart(cart) ? Promise.resolve(cart).then(acceptMutationCart) : getCart())
      .then(function (fresh) { render(fresh); clearError(); return fresh; })
      .catch(function (error) {
        if (lastValidCart) render(lastValidCart);
        else itemsNode.textContent = 'Je winkelwagen kon nog niet worden geladen.';
        showError(error);
        return lastCart;
      }).finally(function () { openingPromise = null; });
    return openingPromise;
  }

  function close() {
    if (!isOpen) return;
    root.classList.remove('is-open');
    checkoutAttempt++;
    resetCheckout();
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sano-cart-open');
    document.body.classList.remove('sano-cart-open');
    isOpen = false;
    if(previewMode)setTimeout(function(){document.dispatchEvent(new CustomEvent('sano:concept-product'));},350);
    unlockPage();
    closeTimer = window.setTimeout(function () {
      root.hidden = true;
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus({ preventScroll: true });
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 260);
  }

  function flushChanges() {
    if (requestInFlight || pendingReads || retryPromise) return;
    var keys = Object.keys(queuedChanges);
    if (!keys.length) return;
    var key = keys[0];
    var quantity = queuedChanges[key];
    var previousLine=lastCart&&lastCart.items.find(function(item){return item.key===key;});
    var previousQuantity=previousLine?previousLine.quantity:0;
    delete queuedChanges[key];
    requestInFlight = true;
    clearError();
    request('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(acceptMutationCart).then(function (cart) {
      render(cart);
      var confirmedLine=cart.items.find(function(item){return item.key===key;});
      if(confirmedLine&&isEligibleItem(confirmedLine)&&confirmedLine.quantity>previousQuantity)celebrateFlavour(null,confirmedLine.quantity-previousQuantity);
      announce(quantity === 0 ? 'Product verwijderd.' : 'Aantal bijgewerkt.');
    }).catch(function (error) {
      queuedChanges = Object.create(null);
      intendedQuantities = Object.create(null);
      showError(error);
      // Keep the last valid cart; never loop on failed writes or replay an add.
    }).finally(function () {
      requestInFlight = false;
      if (!Object.prototype.hasOwnProperty.call(queuedChanges, key)) delete intendedQuantities[key];
      flushChanges();
    });
  }

  function queueChange(key, quantity, delta) {
    var existingItem = lastCart && lastCart.items && lastCart.items.find(function (item) { return item.key === key; });
    if (!existingItem || cartFailure || pendingReads || retryPromise) return;
    if (delta) quantity = (Object.prototype.hasOwnProperty.call(intendedQuantities, key) ? intendedQuantities[key] : Number(existingItem.quantity)) + Number(delta);
    intendedQuantities[key] = Math.max(0, Number(quantity));
    if (isEligibleItem(existingItem) && Number(quantity) > Number(existingItem.quantity)) pendingSavingsIncrease = true;
    queuedChanges[key] = Math.max(0, Number(quantity));
    flushChanges();
  }

  function celebrateFlavour(card, amount) {
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var holder=root.querySelector('.sano-cart__quick-add');
    if(!holder)return;
    document.querySelectorAll('.sano-cart__add-celebration').forEach(function(e){e.remove();});
    var burst=element('div','sano-cart__add-celebration');
    burst.setAttribute('aria-hidden','true');
    burst.appendChild(element('span','sano-cart__add-message','+'+amount+(amount===1?' pot toegevoegd!':' potten toegevoegd!')));
    var glitterCount=matchMedia('(max-width:1024px)').matches?24:48;
    for(var i=0;i<glitterCount;i++){
      var spark=element('i','');
      var angle=i*2.39996;
      var radius=65+(i%8)*13;
      spark.style.setProperty('--dx',Math.cos(angle)*radius+'px');
      spark.style.setProperty('--dy',Math.sin(angle)*radius+'px');
      spark.style.setProperty('--delay',(i%6)*35+'ms');
      spark.style.width=spark.style.height=(i%3===0?9:5)+'px';
      spark.style.background=i%3===0?'#fff2c5':(i%2===0?'#f7cf70':'#dca544');
      burst.appendChild(spark);
    }
    var viewport=window.visualViewport;
    burst.style.left=((viewport?viewport.offsetLeft:0)+(viewport?viewport.width:window.innerWidth)/2)+'px';
    burst.style.top=((viewport?viewport.offsetTop:0)+(viewport?viewport.height:window.innerHeight)/2)+'px';
    document.body.appendChild(burst);
    temporary(function(){burst.remove();},1100,function(){burst.remove();});
  }
  function addUpsell(card) {
    if(!card||card.disabled||requestInFlight)return;
    var id=card.dataset.sanoCartFlavour,chosen=config.eligibleVariants[id];
    if(!chosen||ownerSoldOutVariants[id])return;
    var amount=/^[23]$/.test(card.dataset.addQuantity||'')?Number(card.dataset.addQuantity):1;
    var caption=card.querySelector('small'),previousCaption=caption&&caption.textContent;
    if(caption)caption.textContent='Toevoegen...';
    root.querySelectorAll('[data-sano-cart-flavour]').forEach(function(button){button.disabled=true;});
    card.setAttribute('aria-busy','true');
    window.SanoCart.addSelectedVariant(id,amount,card).then(function(){
      if(caption)caption.textContent='Toegevoegd';
    }).catch(function(error){
      if(caption)caption.textContent=error.code==='ADDED_CART_UNVERIFIED'?'Toegevoegd - vernieuw winkelwagen':'Niet toegevoegd';
      announce(error.message);
    }).finally(function(){
      card.removeAttribute('aria-busy');
      root.querySelectorAll('[data-sano-cart-flavour]').forEach(function(button){var v=config.eligibleVariants[button.dataset.sanoCartFlavour];button.disabled=Boolean(ownerSoldOutVariants[button.dataset.sanoCartFlavour])||!v||!(v.available===true||mysteryVariant(v));});
      temporary(function(){if(caption&&caption.isConnected)caption.textContent=previousCaption;},1600);
    });
  }

  function saveNote() {
    if (!noteNode || requestInFlight || pendingReads || cartFailure) return;
    requestInFlight = true;
    clearError();
    var submittedNote = noteNode.value;
    request('cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: submittedNote })
    }).then(function (cart) { if (noteNode.value === submittedNote) noteDirty = false; render(cart); announce('Notitie opgeslagen.'); })
      .catch(function (error) { showError(error); })
      .finally(function () { requestInFlight = false; flushChanges(); });
  }

  listen(root,'click', function (event) {
    if (event.target.closest('.sano-cart__checkout')) { checkout(event); return; }
    var closeButton = event.target.closest('[data-sano-cart-close]');
    if (closeButton) { event.preventDefault(); close(); return; }
    var change = event.target.closest('[data-sano-cart-change]');
    if (change) { event.preventDefault(); queueChange(change.dataset.sanoCartChange, change.dataset.quantity, change.dataset.quantityDelta); return; }
    var flavour = event.target.closest('[data-sano-cart-flavour]');
    if (flavour) {
      event.preventDefault();
      if (upsellNode) upsellNode.classList.add('has-interacted');
      addUpsell(flavour);
      return;
    }
    if (event.target.closest('[data-sano-cart-note-save]')) { event.preventDefault(); saveNote(); return; }
    if (event.target.closest('[data-sano-cart-retry]')) { event.preventDefault(); retryCart(); }
  });

  buildFlavourCards();

  listen(document,'sano:cart-item-added', function (event) {
    var lineItem = event.detail && event.detail.lineItem;
    if (isEligibleItem(lineItem)) pendingSavingsIncrease = true;
  });

  listen(document,'keydown', function (event) {
    if (!isOpen) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    var nodes = focusables();
    if (!nodes.length) { event.preventDefault(); panel.focus(); return; }
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel || !panel.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || document.activeElement === panel || !panel.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  });

  window.SanoCart = {
    root: root,
    previewMode: Boolean(previewMode),
    destroy: function(){disposed=true;close();clearTimeout(closeTimer);clearTimeout(retryTimer);cancelAnimationFrame(savingsFrame);root.hidden=true;disposers.forEach(function(f){f();});window.SanoCart=null;},
    initialized: true,
    enabled: true,
    isReady: true,
    open: function (trigger) { return open(null, trigger); },
    openWithCart: function (cart, options) {
      console.info('[SANO CART] openWithCart called');
      return open(cart, options && options.trigger);
    },
    close: close,
    refresh: function () { if (requestInFlight) return Promise.resolve(lastCart); return getCart().then(function (cart) { render(cart); clearError(); return cart; }).catch(showError); },
    addSelectedVariant: function (variantId, quantity, trigger) {
      var chosen=config.eligibleVariants[String(variantId)];
      if(Number(variantId)===-1){variantId=Object.keys(config.eligibleVariants).find(function(id){return mysteryVariant(config.eligibleVariants[id]);});chosen=config.eligibleVariants[String(variantId)];}
      // Availability embedded in the page can be stale. Shopify cart/add owns current stock validation.
      if(!chosen) return Promise.reject(new Error('Kies een geldige OUTRAGE-smaak.'));
      if(ownerSoldOutVariants[String(variantId)])return Promise.reject(new Error('Deze smaak is momenteel uitverkocht. Kies Mysterious.'));
      if(!Number.isSafeInteger(quantity)||quantity<1) return Promise.reject(new Error('Kies een geldig aantal potten.'));
      if(cartFailure&&(cartFailure.status===422||cartFailure.status===404)&&!requestInFlight&&!blockedAddRecovery){
        blockedAddRecovery=true;
        return readCurrentCart().then(function(cart){render(cart);clearError();return window.SanoCart.addSelectedVariant(variantId,quantity,trigger);}).finally(function(){blockedAddRecovery=false;});
      }
      if(requestInFlight || pendingReads || cartFailure) return Promise.reject(new Error('Wacht even tot de winkelwagen klaar is.'));
      var addConfirmed=false;
      requestInFlight=true;pendingSavingsIncrease=true;clearError();
      return request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity:quantity}]})})
        .then(function(lineItem){addConfirmed=true;document.dispatchEvent(new CustomEvent('sano:cart-item-added',{detail:{lineItem:lineItem,source:'sano-pdp-quantity'}}));return readAfterConfirmedAdd();})
        .then(function(cart){render(cart);open(cart,trigger);celebrateFlavour(trigger,quantity);announce(quantity+' '+chosen.title+' toegevoegd aan je winkelwagen.');return cart;})
        .catch(function(error){pendingSavingsIncrease=false;
          if(addConfirmed){error=new Error('Je potten zijn toegevoegd, maar het vernieuwen van de winkelwagen lukt nog niet. Open de winkelwagen opnieuw voordat je meer toevoegt.');error.code='ADDED_CART_UNVERIFIED';}
          else if(error.code==='NETWORK'||error.code==='TIMEOUT'){error.message='De toevoeging is niet bevestigd. Open of ververs je winkelwagen voordat je opnieuw toevoegt.';}
          showError(error);throw error;
        })
        .finally(function(){requestInFlight=false;flushChanges();});
    },
    getEligibleQuantity: function () { return lastCart ? eligibleQuantity(lastCart) : 0; }
  };
  console.info('[SANO CART] core initialized');
  // Reconcile after a reload without opening the drawer or taking over checkout.
  // Lazy initialization: the closed drawer must not issue cart/gift requests on every page load.

  if(previewMode && new URLSearchParams(location.search).get('sano_cart')==='open')open();
  console.info('[SANO CART] ready');
  document.dispatchEvent(new CustomEvent('sano:cart-ready'));
  }
  initialize();
  if(!window.__sanoCartLifecycle){
    window.__sanoCartLifecycle=true;
    document.addEventListener('shopify:section:load',initialize);
    document.addEventListener('shopify:section:unload',function(event){if(window.SanoCart&&event.target.contains(window.SanoCart.root))window.SanoCart.destroy();});
  }
})();
